import React from "react";
import Modal from 'react-bootstrap/Modal';
import { Form, FormInput, Button } from "shards-react";
import { connect } from 'react-redux';
import { efectorlistActions } from "../../core/efector-lists";
import { efectoresImportLogActions } from "../../core/efectores-import-log";
import { getEfectoresForCurrentEfectorList } from "../../core/efector-lists";
import { Map } from 'immutable';
import { ErrorsLog } from '../common/errors-log'

class EfectorModalImport extends React.Component {
    constructor(props) {
        super(props);

        this.setSelectedFile = this.setSelectedFile.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.state = {
            selectedFile: null,
            selectedFileName: '',
            errors: null,
            sentImport: false
        }
    }

    setSelectedFile(file) {
        if(this.validFileType(file)) {
            this.setState({
                selectedFile: file,
                selectedFileName: file ? file.name : '',
                errors: null
            })
        } else {
            this.setState({
                selectedFile: null,
                selectedFileName: '',
                errors: {type: 'El archivo debe ser de tipo TXT/CSV/XLS/XLSX'},
            })
        }
    }

    handleClose() {
        this.props.handleClose()
        this.resetForm()
        if(this.state.sentImport)
            this.updateEfectors()
    }

    resetForm() {
        this.setState({
            selectedFile: null,
            selectedFileName: '',
            errors: null
        })
    }

    validFileType(file) {
        let type = file && file.name.split('.').pop();

        if(type === 'txt' || type === 'csv' || type === 'xls' || type === 'xlsx') 
            return true
        return false
    }

    handleSubmit(e) {
      e.preventDefault()
      this.props.uploadEfectores(this.state.selectedFile)
      this.setState({ sentImport: true })
    }

    updateEfectors() {
        this.setState({ sentImport: false })
        this.props.loadEfectores(new Map({
            sessionId: this.props.user.sessionId
        }))
    }

    componentDidUpdate(oldProps,oldState){
        const { efectoresImport } = this.props
        let hasntErrors = efectoresImport && efectoresImport.data && efectoresImport.data.data && efectoresImport.data.data.length === 1 && !efectoresImport.isPending
        if(this.state.sentImport && hasntErrors) {
            this.handleClose()
        }
    }

    render() {
        const { selectedFile, selectedFileName, errors, sentImport } = this.state
        const { show, efectoresImport } = this.props

        return (
            <Modal
                dialogClassName="modal-md"
                show={show}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                style={{ zIndex: 2500 }}
                onHide={() => this.handleClose()}
            >
                <Modal.Header closeButton>
                    <h5 className="m-0">
                        <i className="far fa-user mr-2"></i> Importar Efectores
                    </h5>
                </Modal.Header>
                <Modal.Body className="pt-3">
                    <Form onSubmit={(e) => this.handleSubmit(e)}>
                        <div className="custom-file mb-3">
                            <FormInput type="file" className="custom-file-input" id="fileImport" onChange={(e) => this.setSelectedFile(e.target.files[0])} accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, text/plain" required invalid={errors && errors.type && errors.type != null} valid={!errors && selectedFileName && selectedFileName != ''} />
                            <label className="custom-file-label" htmlFor="fileImport">
                                {selectedFileName ? selectedFileName : 'Seleccione un archivo...'}
                            </label>
                            {errors && errors.type && <div class="invalid-feedback">{errors.type}</div>}
                        </div>
                        
                        <div className="text-right">
                            <Button type="submit" disabled={!selectedFile} className="ml-auto btn-accent btn-sm m-1 btn btn-primary">importar</Button>
                        </div>
                    </Form>
                    { sentImport && !efectoresImport.isPending && efectoresImport.data && efectoresImport.data.data && efectoresImport.data.data.length > 1 && <><hr />  <ErrorsLog mainError={efectoresImport.data.data[efectoresImport.data.data.length-1]} errors={efectoresImport.data.data} /> </>}
                </Modal.Body>

            </Modal>
        )
    }
}


//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = (state, props) => {
    return {
        efectores: getEfectoresForCurrentEfectorList(state, props),
        efectoresImport: state.efectoresImportLog,
        user: state.session.user
    }
};

const mapDispatchToProps = {
    uploadEfectores: efectoresImportLogActions.uploadEfectores,
    loadEfectores: efectorlistActions.loadEfectores,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EfectorModalImport);
